import { type BackOfficeFeatures } from '@bluebrick/electron-api-module'
import { defineStore, storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { fetchUserFeatures } from '@/features/user/userRemoteRepository'
import { useUserStore } from '@/features/user/useUserStore'

const useFeatureFlagInnerStore = defineStore('featureFlagInner', () => {
	const features = ref<Array<BackOfficeFeatures>>([])

	return {
		features
	}
})

export const useFeatureFlagStore = defineStore('featureFlag', () => {
	const innerStore = useFeatureFlagInnerStore()
	const { user } = storeToRefs(useUserStore())

	const hasScrapersEnabled = computed(() => innerStore.features.includes('scrapers') && user.value?.readonly !== true)
	const shouldAnonymizeData = computed(() => innerStore.features.includes('da-anonymize-data'))
	const hasDiscountSettersEnabled = computed(() => innerStore.features.includes('saas-discount-setters'))

	async function refresh() {
		innerStore.features = (await fetchUserFeatures()) ?? []
	}

	return {
		hasScrapersEnabled,
		refresh,
		shouldAnonymizeData,
		hasDiscountSettersEnabled
	}
})
